import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format, parseISO, isValid } from 'date-fns';
import { enUS } from 'date-fns/locale';

const PRESETS = [
  { label: 'Live',  ms: null },
  { label: '−1h',   ms: 1 * 60 * 60 * 1000 },
  { label: '−6h',   ms: 6 * 60 * 60 * 1000 },
  { label: '−24h',  ms: 24 * 60 * 60 * 1000 },
  { label: '−7d',   ms: 7 * 24 * 60 * 60 * 1000 },
];

const TimeControl = ({ asOf, onChange }) => {
  const isLive = !asOf;

  const setRelative = (ms) => {
    if (ms == null) return onChange?.(null);
    onChange?.(new Date(Date.now() - ms).toISOString());
  };

  let displayTime = 'now (auto-refresh on)';
  if (asOf) {
    try {
      const d = parseISO(asOf);
      if (isValid(d)) {
        displayTime = format(d, "yyyy-MM-dd HH:mm 'UTC'", { locale: enUS });
      }
    } catch { /* keep default */ }
  }

  return (
    <div className={`time-control ${isLive ? 'time-control--live' : 'time-control--past'}`}>
      <span className="time-control-status">
        {isLive ? 'As of' : 'Viewing as of'}
      </span>

      <div className="time-control-presets" role="group" aria-label="Quick time presets">
        {PRESETS.map(({ label, ms }) => (
          <button
            key={label}
            type="button"
            className={`btn-table ${(label === 'Live' && isLive) ? 'on' : ''}`}
            onClick={() => setRelative(ms)}
            title={ms == null ? 'Live (now)' : `Set to ${label} ago`}
            aria-pressed={label === 'Live' && isLive}
          >
            {label}
          </button>
        ))}
      </div>

      <div className="time-control-wrapper" style={{ marginLeft: 'auto' }}>
        <DatePicker
          selected={asOf ? new Date(asOf) : null}
          onChange={(date) => onChange(date ? date.toISOString() : null)}
          showTimeSelect
          timeIntervals={15}
          timeFormat="HH:mm"
          dateFormat="yyyy-MM-dd HH:mm"
          maxDate={new Date()}
          placeholderText="Custom moment…"
          isClearable
          className="input-field time-control-input"
          popperClassName="time-control-popper"
          ariaLabelledBy="time-control-status"
        />
      </div>

      <span className="time-control-status" style={{ minWidth: 130, textAlign: 'right', textTransform: 'none', letterSpacing: 0, fontFamily: 'IBM Plex Mono, monospace', color: 'var(--text)' }}>
        {displayTime}
      </span>
    </div>
  );
};

export default TimeControl;
